import { Navigate, useNavigate, useParams } from 'react-router-dom';
import PageTitle from '../../components/PageTitle';
import PatientInformationHeader from '../../components/Patient/PatientInformationHeader';
import {
    useGetPatientDetailsQuery,
    useGetPatientOrdersQuery,
    useUpdateMedOrderMutation,
    useUpdateOrderStatusMutation,
} from '../../features/patient/patientService';
import OrderMedicationForm from '../../components/Orders/OrderMedicationForm';
import { OrderStatusEnum } from '../../models/PatientModels';
import { Button } from 'antd';
import useOrderToast from '../../hooks/useOrderToast';

const UpdateOrder = () => {
    const navigate = useNavigate();
    const { id: patientId = '', orderId = '' } = useParams();

    const { toast } = useOrderToast();

    const { data: patientOrders, isLoading } = useGetPatientOrdersQuery({
        patientId: patientId,
        orderStatus: OrderStatusEnum.Draft,
    });
    const { data: patientDetails, isLoading: patientDetailsLoading } =
        useGetPatientDetailsQuery({ id: patientId });

    const [updateMedOrder, { isLoading: updatingMedOrder }] =
        useUpdateMedOrderMutation();

    const [updateOrderStatus, { isLoading: isUpdatingOrderStatus }] =
        useUpdateOrderStatusMutation();

    const order = patientOrders?.find(
        (patientOrder) => patientOrder.id === orderId,
    );

    if (!isLoading && !order)
        return <Navigate to={`/patient/${patientId}/add-new-medication`} />;

    const onSubmit = async (data: any) => {
        return await updateMedOrder({ ...data, orderId: orderId });
    };

    const onDelete = async () => {
        await updateOrderStatus({
            orderStatus: OrderStatusEnum.Inactive,
            orderId: orderId,
            patientId,
        });
        toast('The order deletion was successful.', 'success');
    };

    return (
        <div>
            <PageTitle
                title="Update Medication"
                onClick={() =>
                    navigate(`/patient/${patientId}/add-new-medication`)
                }
            />
            <div className="mx-5">
                {patientDetails && (
                    <PatientInformationHeader
                        patient={patientDetails}
                        navigate={() => navigate(-2)}
                    />
                )}
                <OrderMedicationForm
                    toastMessage="The medication details were successfully updated."
                    order={order}
                    cancelButton={
                        <Button
                            danger
                            onClick={onDelete}
                            className="me-4"
                            loading={isUpdatingOrderStatus}
                            style={{
                                width: 120,
                            }}
                            shape="round"
                        >
                            Delete
                        </Button>
                    }
                    onSubmit={onSubmit}
                    isSubmitting={updatingMedOrder}
                    submitLabel="Save to Queue"
                />
            </div>
        </div>
    );
};

export default UpdateOrder;
